<template>
    <div class="container">
        <img src="/fake/店铺.png" alt="">
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; /*display: flex; flex-direction: column; align-items: stretch;*/ text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        overflow: auto;
        img{ width: 1808px; height: 881px; }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
